import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getReleaseAppOS } from "src/apis/VersionRelease/operatingSystem.api";
import Controls from "src/components/form/controls/Controls";

const ReleaseAppVersionPanelOptional = ({ releaseAppOSId, onChange }) => {
  const [releaseAppOSs, setReleaseAppOss] = useState([]);

  useEffect(() => {
    getReleaseAppOS({}, (result) => {
      setReleaseAppOss([{ id: "all", name: "All" }, ...result.list]);
    });
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="releaseAppOSId"
        label="OS Name"
        value={releaseAppOSId}
        onChange={(e) => onChange(e.target.value)}
        options={releaseAppOSs}
        searchable={false}
        style={{ width: "150px" }}
      />
    </div>
  );
};

export default ReleaseAppVersionPanelOptional;
